import { useState } from "react";
import { HandCoins } from "lucide-react";
import { toast } from "sonner";
import { startCheckout, formatApiError } from "@/lib/api";

const TIPS = [{ key: "tip_5", label: "£5" }, { key: "tip_15", label: "£15" }, { key: "tip_50", label: "£50" }];

export const TipJar = ({ articleSlug, compact = false }) => {
  const [sel, setSel] = useState("tip_15");
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try { await startCheckout(sel, { article_slug: articleSlug }); } catch (e) { toast.error(formatApiError(e)); setBusy(false); }
  };
  return (
    <div data-testid="tip-jar" className={`border border-[#E7E7E7] bg-white ${compact ? "p-5" : "p-8"}`}>
      <div className="flex items-center gap-2 overline text-[#0A0A0A]"><HandCoins size={14} /> Support the journalism</div>
      <p className={`font-display font-semibold mt-3 ${compact ? "text-lg" : "text-2xl"}`}>Fund field reporting from Africa's farm gates.</p>
      <p className="text-sm text-[#575757] mt-2 leading-relaxed">Every contribution funds on-the-ground reporting across cashew hubs, coffee washing stations and cocoa cooperatives.</p>
      <div className="grid grid-cols-3 gap-2 mt-5">
        {TIPS.map((t) => (
          <button key={t.key} data-testid={`tip-amount-${t.key}`} onClick={() => setSel(t.key)}
            className={`py-3 font-mono-d text-sm border transition-colors ${sel === t.key ? "bg-[#0A0A0A] text-white border-[#0A0A0A]" : "border-[#E7E7E7] hover:border-[#0A0A0A]"}`}>
            {t.label}
          </button>
        ))}
      </div>
      <button data-testid="tip-jar-donate-btn" disabled={busy} onClick={go} className="mt-3 w-full bg-[#E5332A] text-white py-3 text-sm font-medium hover:bg-[#B8241C] transition-colors">
        {busy ? "Opening secure checkout…" : "Contribute securely"}
      </button>
    </div>
  );
};
